import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Account creation now happens at ctOneAuth. After signing in, brand-new users
// are returned here and can create their company from the in-app onboarding.
export default function Register() {
  const { loginWithOIDC } = useAuth();

  return (
    <div
      className="flex items-center justify-center px-4"
      style={{ minHeight: '100vh', background: 'var(--scpa-bg)' }}
    >
      <div className="card w-full max-w-sm">
        <h1 className="text-xl font-semibold text-fg mb-2">
          Create your account
        </h1>
        <p className="text-sm text-muted mb-6">
          Accounts are managed by ctOneAuth. You'll be redirected to register, then
          brought back here to set up your workspace.
        </p>
        <button
          type="button"
          onClick={() => loginWithOIDC('/')}
          className="btn btn-primary w-full"
        >
          Continue to ctOneAuth
        </button>
        <p className="mt-4 text-center text-sm text-muted">
          Already have an account?{' '}
          <Link to="/login" className="text-primary hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
